import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const useNewUserRolesInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const modifiedReq = req.clone({
    headers: req.headers.set('use-new-user-role-strings', 'true'),
  });
  return next(modifiedReq);
};
